import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class LeaseDashboard extends Component {
    static displayName = LeaseDashboard.name;

    constructor(props) {
        super(props);
        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            candidates: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            leaseData: {}
        };
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
        this.GetLeaseData();
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ candidates: data });
    }


    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.candidates.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.candidates.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.candidates.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.candidates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            candidates: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.candidates;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            candidates: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {
        return (
            <>
                <div>
                    <Container>
                        <Row>
                            <Col>
                                <h3>Dashboard</h3>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col xl='5' lg='5' md='5' sm='5' xs='5'>
                                <Table responsive>
                                    <tbody>
                                        {this.state.loading === true && this.state.loadingDocument === false ? (
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <Spinner color="primary" children='' />
                                                </td>
                                            </tr>

                                        ) : (
                                            <>
                                                {!this.state.noResults && this.state.leaseData ? (
                                                    <>
                                                        <tr>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>Active Leases:</td>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{this.state.leaseData.openLeases}</td>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}></td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>Total SF Leased:</td>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{this.state.leaseData.totalSF}</td>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}></td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>Avg SF Leased:</td>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{this.state.leaseData.avgSF}</td>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}></td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}># of critical dates in 12 months:</td>
                                                            <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>{this.state.leaseData.crit12}</td>
                                                                <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }}>
                                                                    <NavLink className="noNavLink"
                                                                        tag={Link}
                                                                        to={'/Lease/CriticalDates-List'}
                                                                    >
                                                                        view
                                                                    </NavLink>
                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                        <h5>No Results Found</h5>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
    numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    async GetLeaseData() {
        this.setState({ loading: true, loadingDocument: false });
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetLeaseData', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        const data = await response.json();
        //this.state.leaseData
        data.openLeases = this.numberWithCommas(data.openLeases);
        data.totalSF = this.numberWithCommas(data.totalSF);
        data.avgSF = this.numberWithCommas(data.avgSF);
        data.crit12 = this.numberWithCommas(data.crit12);
        //crit12
        this.setState({ leaseData: data, loading: false, noResults: data.length === 0 ? true : false });
    }
}

